<template>
  <simpleDiag
    title="回单下载"
    :onlyOK="true"
    :isShow="isShow"
    @close="close"
    @confirm="close">
    <div v-if="!noData">
      <ul class="page-info-list verify" v-loading="loading">
        <li class="page-info-item">
          <label class="page-info-tit">电子回单号:</label>
          <span class="page-info-val">{{curId}}</span>
        </li>
        <li class="page-info-item">
          <label class="page-info-tit">回单验证码:</label>
          <span class="page-info-val">{{curCode}}</span>
        </li>
        <li class="page-info-item">
          <label class="page-info-tit">下载地址:</label>
          <span class="page-info-val" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
            <a :href="curUrl" target="_blank" :title="curUrl">{{curUrl}}</a>
          </span>
        </li>
      </ul>
    </div>
   <div style="text-align: center; height: 86px; line-height: 86px;" v-else>
     暂无数据
   </div>
  </simpleDiag>
</template>
<script>
import simpleDiag from '@/components/dialogs/simpleDiag'
export default {
  components: { simpleDiag },
  props: {
    noData: Boolean, // 回单是否有数据
    isShow: Boolean, // 弹框是否显示
    curId: String,
    curCode: String,
    curUrl: String,
    loading: Boolean
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>
